define("calendar/components/calendar/social-profiles/avatar", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/service", "@ember/string", "@glimmer/tracking", "later/utils/profile-colors", "shared/utils/handle-key-down", "shared/utils/constants/keys"], function (_exports, _component, _templateFactory, _component2, _object, _service, _string, _tracking, _profileColors, _handleKeyDown, _keys) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@ember/service",0,"@ember/string",0,"@glimmer/tracking",0,"later/utils/profile-colors",0,"shared/utils/handle-key-down",0,"shared/utils/constants/keys",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <span class="cCA--account__item {{additionalClasses}}">
    {{!-- template-lint-disable no-down-event-binding --}}
    <Shared::ProfileAvatar
      class="cCA--user {{if this.isSelected "" "is--unselected"}}"
      tabindex="0"
      aria-selected={{this.isSelected}}
      @socialProfile={{@socialProfile}}
      @showPlatform={{true}}
      @showOutline={{true}}
      {{on "click" (fn this.showSingleProfile @socialProfile)}}
      {{on "keydown" this.showSingleProfileKeyboard}}
      >
      {{! Add Icon}}
      {{#if this.onlyProfileSelected}}
        <span class="cCA--account__action--primary is--selected is--only">
          {{svg-jar "verified" class="o--icon--md o--icon--white cCA--account__icon"}}
        </span>
      {{else}}
        {{!-- template-lint-disable no-down-event-binding --}}
        <span 
          tabindex="0" 
          class="cCA--account__action--primary {{if this.isSelected "is--selected" "is--unselected"}}" 
          role="radio"
          aria-checked={{this.isSelected}}
          {{on "click" (fn this.toggleMultiCalProfile @socialProfile)}}
          {{on "keydown" this.toggleMultiCalProfileKeyboard}}
        >
          {{#if this.isSelected}}
            {{svg-jar "verified" class="o--icon--md o--icon--white cCA--account__icon qa--add_multi_profile_btn"}}
          {{else}}
            {{svg-jar "verified" class="o--icon--md cCA--account__icon qa--add_multi_profile_btn"}}
          {{/if}}
        </span>
      {{/if}} 
      {{! More Options Icon}}
      <span class="cCA--account__action--secondary {{this.dropdownTargetClass}}" {{on "click" (fn this.trackShowProfileDetails @socialProfile)}}>
        {{svg-jar "ellipsis-h-solid" class="o--icon--xs o--icon--white"}}
      </span>
    </Shared::ProfileAvatar>
  
    <span class="cCA--user__name qa--profile_nickname {{if this.isSelected "u--text--bold" "u--text--light"}}">
      {{@socialProfile.nickname}}
    </span>
  
    <Shared::Ui::EmberDrop
      @target={{concat "." this.dropdownTargetClass}}
      @position="bottom center"
      @constrainToWindow={{true}}
      @constrainToScrollParent={{false}}
      @contentSelector=".e--multiProfile__drop"
      @openOn="click"
      @hoverOpenDelay="200"
    >
      <div class="o--dropWrapper e--multiProfile__drop">
        <div class="o--dropBody">
          <ul class="o--dropBody__list">
            <li class="o--dropBody__item u--p__sm">
              <p class="u--text--light  u--m__tb__0">
                {{t "app.entities.social_profile"}}
              </p>
              <p class="u--text--md u--text--bold u--m__tb__0 u--ellipsis">
                {{@socialProfile.displayName}}
              </p>
            </li>
          </ul>
        </div>
        <div class="o--dropFooter">
          <div class="u--row" {{on "click" this.toggleShowSecondary}}>
            <div class="u--col__12 u--p__sm u--text--md">
              {{t "header.switching.multi_cal.custom_color"}}
              <div class="{{profile-color-class @socialProfile.profileColorClass}} u--float--right u--m__tb__0 {{if this.showSecondary "u--hide"}}">
              </div>
            </div>
          </div>
          {{#if this.showSecondary}}
            {{#each this.availableColors as |colorClass|}}
              <Shared::Ui::ProfileColorOption
                @colorClass={{colorClass}}
                @socialProfile={{@socialProfile}}
                @trackSelection={{this.trackChangedProfileColor}}
              />
            {{/each}}
          {{/if}}
        </div>
      </div>
    </Shared::Ui::EmberDrop>
  </span>
  
  */
  {
    "id": "yEOpIoZx",
    "block": "[[[10,1],[15,0,[29,[\"cCA--account__item \",[36,0]]]],[12],[1,\"\\n\"],[1,\"  \"],[8,[39,1],[[16,0,[29,[\"cCA--user \",[52,[30,0,[\"isSelected\"]],\"\",\"is--unselected\"]]]],[24,\"tabindex\",\"0\"],[16,\"aria-selected\",[30,0,[\"isSelected\"]]],[4,[38,3],[\"click\",[28,[37,4],[[30,0,[\"showSingleProfile\"]],[30,1]],null]],null],[4,[38,3],[\"keydown\",[30,0,[\"showSingleProfileKeyboard\"]]],null]],[[\"@socialProfile\",\"@showPlatform\",\"@showOutline\"],[[30,1],true,true]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"onlyProfileSelected\"]],[[[1,\"      \"],[10,1],[14,0,\"cCA--account__action--primary is--selected is--only\"],[12],[1,\"\\n        \"],[1,[28,[35,5],[\"verified\"],[[\"class\"],[\"o--icon--md o--icon--white cCA--account__icon\"]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[11,1],[24,\"tabindex\",\"0\"],[16,0,[29,[\"cCA--account__action--primary \",[52,[30,0,[\"isSelected\"]],\"is--selected\",\"is--unselected\"]]]],[24,\"role\",\"radio\"],[16,\"aria-checked\",[30,0,[\"isSelected\"]]],[4,[38,3],[\"click\",[28,[37,4],[[30,0,[\"toggleMultiCalProfile\"]],[30,1]],null]],null],[4,[38,3],[\"keydown\",[30,0,[\"toggleMultiCalProfileKeyboard\"]]],null],[12],[1,\"\\n\"],[41,[30,0,[\"isSelected\"]],[[[1,\"          \"],[1,[28,[35,5],[\"verified\"],[[\"class\"],[\"o--icon--md o--icon--white cCA--account__icon qa--add_multi_profile_btn\"]]]],[1,\"\\n\"]],[]],[[[1,\"          \"],[1,[28,[35,5],[\"verified\"],[[\"class\"],[\"o--icon--md cCA--account__icon qa--add_multi_profile_btn\"]]]],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n\"]],[]]],[1,\"    \"],[11,1],[16,0,[29,[\"cCA--account__action--secondary \",[30,0,[\"dropdownTargetClass\"]]]]],[4,[38,3],[\"click\",[28,[37,4],[[30,0,[\"trackShowProfileDetails\"]],[30,1]],null]],null],[12],[1,\"\\n      \"],[1,[28,[35,5],[\"ellipsis-h-solid\"],[[\"class\"],[\"o--icon--xs o--icon--white\"]]]],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]]]]],[1,\"\\n\\n  \"],[10,1],[15,0,[29,[\"cCA--user__name qa--profile_nickname \",[52,[30,0,[\"isSelected\"]],\"u--text--bold\",\"u--text--light\"]]]],[12],[1,\"\\n    \"],[1,[30,1,[\"nickname\"]]],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[8,[39,6],null,[[\"@target\",\"@position\",\"@constrainToWindow\",\"@constrainToScrollParent\",\"@contentSelector\",\"@openOn\",\"@hoverOpenDelay\"],[[28,[37,7],[\".\",[30,0,[\"dropdownTargetClass\"]]],null],\"bottom center\",true,false,\".e--multiProfile__drop\",\"click\",\"200\"]],[[\"default\"],[[[[1,\"\\n    \"],[10,0],[14,0,\"o--dropWrapper e--multiProfile__drop\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"o--dropBody\"],[12],[1,\"\\n        \"],[10,\"ul\"],[14,0,\"o--dropBody__list\"],[12],[1,\"\\n          \"],[10,\"li\"],[14,0,\"o--dropBody__item u--p__sm\"],[12],[1,\"\\n            \"],[10,2],[14,0,\"u--text--light  u--m__tb__0\"],[12],[1,\"\\n              \"],[1,[28,[35,8],[\"app.entities.social_profile\"],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,2],[14,0,\"u--text--md u--text--bold u--m__tb__0 u--ellipsis\"],[12],[1,\"\\n              \"],[1,[30,1,[\"displayName\"]]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"o--dropFooter\"],[12],[1,\"\\n        \"],[11,0],[24,0,\"u--row\"],[4,[38,3],[\"click\",[30,0,[\"toggleShowSecondary\"]]],null],[12],[1,\"\\n          \"],[10,0],[14,0,\"u--col__12 u--p__sm u--text--md\"],[12],[1,\"\\n            \"],[1,[28,[35,8],[\"header.switching.multi_cal.custom_color\"],null]],[1,\"\\n            \"],[10,0],[15,0,[29,[[28,[37,9],[[30,1,[\"profileColorClass\"]]],null],\" u--float--right u--m__tb__0 \",[52,[30,0,[\"showSecondary\"]],\"u--hide\"]]]],[12],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"],[41,[30,0,[\"showSecondary\"]],[[[42,[28,[37,11],[[28,[37,11],[[30,0,[\"availableColors\"]]],null]],null],null,[[[1,\"            \"],[8,[39,12],null,[[\"@colorClass\",\"@socialProfile\",\"@trackSelection\"],[[30,2],[30,1],[30,0,[\"trackChangedProfileColor\"]]]],null],[1,\"\\n\"]],[2]],null]],[]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"@socialProfile\",\"colorClass\"],false,[\"additionalClasses\",\"shared/profile-avatar\",\"if\",\"on\",\"fn\",\"svg-jar\",\"shared/ui/ember-drop\",\"concat\",\"t\",\"profile-color-class\",\"each\",\"-track-array\",\"shared/ui/profile-color-option\"]]",
    "moduleName": "calendar/components/calendar/social-profiles/avatar.hbs",
    "isStrictMode": false
  });

  let AvatarComponent = (_class = class AvatarComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "errors", _descriptor2, this);

      _initializerDefineProperty(this, "router", _descriptor3, this);

      _initializerDefineProperty(this, "segment", _descriptor4, this);

      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor5, this);

      _initializerDefineProperty(this, "showSecondary", _descriptor6, this);
    }

    get availableColors() {
      return _profileColors.availableColors;
    }

    get dropdownTargetClass() {
      return "e--multiProfile__target".concat(this.args.socialProfile.id);
    }

    get onlyProfileSelected() {
      var _this$selectedSocialP;

      return ((_this$selectedSocialP = this.selectedSocialProfiles.profiles) === null || _this$selectedSocialP === void 0 ? void 0 : _this$selectedSocialP.length) === 1 && this.isSelected;
    }

    get isSelected() {
      var _this$selectedSocialP2;

      return (_this$selectedSocialP2 = this.selectedSocialProfiles.profiles) === null || _this$selectedSocialP2 === void 0 ? void 0 : _this$selectedSocialP2.includes(this.args.socialProfile);
    }

    get additionalClasses() {
      const className = ':at--multiProfilePost__addProfile';
      const formattedSocialProfile = (0, _string.capitalize)(this.args.socialProfile.toString());
      return "is".concat(formattedSocialProfile).concat(className).concat(formattedSocialProfile);
    }

    async showSingleProfile(socialProfile) {
      if (socialProfile.isTiktokUnverifiedAccount && this.auth.currentAccount.canConnectTiktokApi) {
        this.args.openTiktokRefreshModal(socialProfile);
      } else {
        await this.selectedSocialProfiles.selectSingleProfile(socialProfile);
      }
    }

    toggleMultiCalProfile(socialProfile, event) {
      event.stopPropagation();

      if (this.selectedSocialProfiles.profiles.includes(socialProfile)) {
        this.selectedSocialProfiles.removeSingleProfile(socialProfile);
      } else {
        this.selectedSocialProfiles.addProfileAndTransition(socialProfile);
      }
    }

    toggleMultiCalProfileKeyboard(event) {
      (0, _handleKeyDown.default)(event, _keys.default.SPACE, () => {
        this.toggleMultiCalProfile(this.args.socialProfile, event);
      });
    }

    showSingleProfileKeyboard(event) {
      (0, _handleKeyDown.default)(event, _keys.default.SPACE, () => {
        this.showSingleProfile(this.args.socialProfile);
      });
    }

    toggleShowSecondary() {
      this.showSecondary = !this.showSecondary;
    }

    trackShowProfileDetails(socialProfile, event) {
      event.stopPropagation();
      this.segment.track('viewed-profile-details-multi-cal', {
        social_profile_handle: socialProfile.nickname,
        profile_network: socialProfile.profileType
      });
    }

    trackChangedProfileColor(socialProfile, colorClass) {
      socialProfile.set('profileColorClass', colorClass);
      socialProfile.save().catch(adapterError => this.errors.handleAdapter(adapterError, socialProfile));
      this.toggleShowSecondary();
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "showSecondary", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "showSingleProfile", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "showSingleProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleMultiCalProfile", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleMultiCalProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleMultiCalProfileKeyboard", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleMultiCalProfileKeyboard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showSingleProfileKeyboard", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "showSingleProfileKeyboard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleShowSecondary", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleShowSecondary"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackShowProfileDetails", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackShowProfileDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackChangedProfileColor", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackChangedProfileColor"), _class.prototype)), _class);
  _exports.default = AvatarComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, AvatarComponent);
});